import script from "./CopywritingView.vue?vue&type=script&setup=true&lang=js"
export * from "./CopywritingView.vue?vue&type=script&setup=true&lang=js"

import "./CopywritingView.vue?vue&type=style&index=0&id=c5579814&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5579814"]])

export default __exports__